import {FieldValues, useFormState} from 'react-hook-form';

import {Button, ButtonProps} from '../Button/Button';
import {FormControl} from '../Form/types';

export interface FormButtonProps<TFieldValues extends FieldValues = FieldValues>
  extends ButtonProps {
  control: FormControl<TFieldValues>;
}

export function FormButton<TFieldValues extends FieldValues = FieldValues>(
  props: FormButtonProps<TFieldValues>
) {
  const {control, ...buttonProps} = props;
  const {isSubmitting, disabled} = useFormState<TFieldValues>({control});

  const isDisabled = disabled || props.isDisabled;

  return (
    <Button
      {...buttonProps}
      isDisabled={isDisabled}
      isLoading={props.isLoading || isSubmitting}
      form={control.formId}
    />
  );
}

/**
 * @about Use FormButton component to compose RHF forms
 */
